import React from "react";
import { Link } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LoginPage() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F7F7] px-6" data-testid="login-page">
      <div className="bg-white border border-neutral-200 p-10 sm:p-14 max-w-md w-full text-center shadow-sm">
        <Link to="/" className="font-serif-display text-2xl text-[#1a1a1a] hover:text-[#6B1F2A] transition-colors inline-block mb-10">
          Spirit <span className="text-[#6B1F2A]">&</span> Associates
        </Link>
        <p className="label-eyebrow mb-3">Admin access</p>
        <h1 className="font-serif-display text-3xl sm:text-4xl mb-4 leading-tight text-[#1a1a1a]">Welcome back</h1>
        <p className="text-sm text-neutral-600 mb-10 leading-relaxed">Sign in with Google to manage pages, blog posts, media, and contact submissions.</p>

        <button onClick={handleGoogleLogin} className="btn-primary-burgundy w-full justify-center" data-testid="google-login-btn">
          Continue with Google
        </button>

        <p className="text-xs text-neutral-400 mt-8">Access restricted to authorized administrators.</p>
      </div>
    </div>
  );
}
